import type { CardSuggestion } from '@confluent/shared/lib/conversation-ui/cards';
import { ActionChip } from './ActionChip.js';
import { useConversationSay } from './SayContext.js';

/**
 * Comp `.chips` — follow-up chips offered by the agent. Each one says its
 * `message` back into the conversation.
 */
export function SuggestionChips({
  items,
  conversationId,
  disabled,
}: {
  items: CardSuggestion[];
  conversationId: string;
  disabled?: boolean;
}) {
  const say = useConversationSay(conversationId);
  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item, i) => (
        <ActionChip key={`${item.label}-${i}`} onClick={() => say(item.message)} disabled={disabled}>
          {item.label}
        </ActionChip>
      ))}
    </div>
  );
}
